import {
  CreateStopwatchRequest,
  PauseStopwatchRequest,
  Stopwatch,
  UpdateStopwatchRequest,
} from '@/types';

import { apiUrls } from './apiUrls';
import { createApiInstance } from './createApiInstance';
import { ItemResponse, ItemsResponse } from './types';

class StopwatchesApi {
  private axiosInstance = createApiInstance('stopwatches');

  async list(): Promise<Stopwatch[]> {
    const response = await this.axiosInstance.get<ItemsResponse<Stopwatch>>(
      apiUrls.stopwatches.list,
    );

    return response.data.items;
  }

  async create(data: CreateStopwatchRequest): Promise<Stopwatch> {
    const response = await this.axiosInstance.post<ItemResponse<Stopwatch>>(
      apiUrls.stopwatches.create,
      data,
    );

    return response.data.item;
  }

  async update(id: string, data: UpdateStopwatchRequest): Promise<Stopwatch> {
    const response = await this.axiosInstance.put<ItemResponse<Stopwatch>>(
      apiUrls.stopwatches.update(id),
      data,
    );

    return response.data.item;
  }

  async remove(id: string): Promise<void> {
    await this.axiosInstance.delete(apiUrls.stopwatches.delete(id));
  }

  async start(id: string): Promise<Stopwatch> {
    const response = await this.axiosInstance.post<ItemResponse<Stopwatch>>(
      apiUrls.stopwatches.start(id),
    );

    return response.data.item;
  }

  async pause(id: string, data: PauseStopwatchRequest): Promise<Stopwatch> {
    const response = await this.axiosInstance.post<ItemResponse<Stopwatch>>(
      apiUrls.stopwatches.pause(id),
      data,
    );

    return response.data.item;
  }

  async finish(id: string): Promise<void> {
    await this.axiosInstance.post(apiUrls.stopwatches.finish(id));
  }
}

export const stopwatchesApi = new StopwatchesApi();
